import React from "react";
import PropTypes from "prop-types";
import { isJaguar, isSuperadmin, isClient } from "../../utility/UserUtils"
import HoldMessageModal from "../../events/holds/HoldMessageModal"
import Cookies from 'universal-cookie'
import { fetchAPI } from "@/utility/NetworkUtils";
import NavbarShoppingCart from "./NavbarShoppingCart";
import UserMenu from "./UserMenu";
import { TextField, InputAdornment, Breadcrumbs } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import BreadcrumbsSubheader from "@/layouts/breadcrumbs/Breadcrumbs";
class PublicCatalogNavbar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      userMenuOpen: false,
      renters: null,
      groups: null,
      search: null,
    }
    this.updateSearchInput = this.updateSearchInput.bind(this);

    this.toggleUserMenu = this.toggleUserMenu.bind(this);
    this.searchSubmit = this.searchSubmit.bind(this);
  } 

  fetchGroups() {
    const { renter } = this.props;
    fetchAPI(`/webapi/renters/${renter ? renter.id : "jaguar"}/groups`, (json)=> {
      if (!json.errors) {
        this.setState({groups: json.groups})
      } else {
        console.log({
          errors: json.errors
        })
      }
    }, {});
  }

  fetchRenters() {
    fetchAPI(`/webapi/renters`, (json)=> {
      if (!json.errors) {
        this.setState({renters: json.renters})
      } else {
        console.log({
          errors: json.errors
        })
      }
    }, {});
  }

  componentDidMount() {
    this.fetchGroups();
    const {user} = this.props;
    if(user && isClient(user)) {
      this.fetchRenters();
    }
  }

  toggleUserMenu(override = undefined) {
    this.setState({
      userMenuOpen: override == undefined ? !this.state.userMenuOpen : override
    })
  }

  renderWarehouseLink() {
    const { user } = this.props;
    if(isSuperadmin(user)) {
      return (
        <a href="/warehouse">Warehouse</a>
      );
    }
  }

  renderGroupLinks() {
    const { user, currentGroup, renter} = this.props;
    const { groups } = this.state;

    const sortedGroups = (groups||[]).sort((a,b)=> this.getSortOrder(a) - this.getSortOrder(b));

    return sortedGroups.filter(x=>x).map(group=>
      <a 
        className={currentGroup == group ? "active" : ""} 
        href={renter ? `/inventory/${renter.id}/category/${group}` : `/category/${group}`}
      >
        <span className="sub-sub-navbar-categories-name">
          {group}
        </span>
        <div className="sub-sub-navbar-categories-divider"></div>
      </a>
    )
  }

  isSubheaderActive(name, id) {
    const currentActive = this.getCurrentActiveSubheader();
    return currentActive.name == name && currentActive.id == id
  }

  getCurrentActiveSubheader() {
    const path = window.location.pathname
    const { renter, currentPage } = this.props;
    if(path == "/receiving_list") {
      return {
        id: null,
        name: "receiving_list"
      }
    }
    else if(path == "/reports" || currentPage=="reports") {
      return {
        id: null,
        name: "reports"
      }
    }
    else if(path == "/inventory") {
      return {
        id: null,
        name: "clients"
      }
    }
    else if(path.startsWith("/orders")) {
      return {
        id: null,
        name: "orders"
      }
    }
    else if (path.startsWith("/events")) {
      return {
        id: null,
        name: "events"
      }
    }
    else if(renter && 
      (currentPage=="home" || (currentPage||"").startsWith(`inventory-`))
    ) {
      return {
        id: renter.id,
        name: "inventory"
      }
    } else if(currentPage=="home" || path.startsWith(`/category`)) {
      return{
        name: "inventory",
        id: null
      }
    }
    return {
      name: null,
      id: null
    }
  }

  renderEventsLink() {
    const { events, user } = this.props;
    if(user && user.id) {
      return (
        <a className={this.isSubheaderActive("events", null) ? "active" : ""} href="/events">
          Events
        </a>
      );
    }
  }

  renderOrdersLink() {
    const { user } = this.props;
    if(user && user.id) {
      return (
        <a className={this.isSubheaderActive("orders", null) ? "active" : ""} href="/orders">
          Orders
        </a>
      );
    }
  }


  renderReportsLink() {
    const path = window.location.pathname
    const { user, renter } = this.props;
    if(user && user.role) {
      return (
        <a className={this.isSubheaderActive("reports", null) ? "active " : " "} href={`/reports`}>
          Reports
        </a>
      );
    }
  }

  renderRecievingList () {
    const { user } = this.props;
    if(user && isJaguar(user) || isClient(user)) {
      return (
        <a className={this.isSubheaderActive("receiving_list", null) ? "active" : ""} href="/receiving_list">
          Receiving List
        </a>
      );
    }
  }

  renderClientsLink () {
    const { user } = this.props;
    if(user && isJaguar(user)) {
      return (
        <a className={this.isSubheaderActive("clients", null) ? "active" : ""} href="/inventory">
          Clients
        </a>
      );
    }
  }

  renderInventory() {
    const { user, currentPage, renter } = this.props;

    const { renters } = this.state;
    if(isClient(user)) {
      return (renters||[{name:"", id: ""}]).map(renter1=>
        <a
          href={renter1.id ? `/inventory/${renter1.id}` : "/"}
          className={(this.isSubheaderActive("inventory", renter1.id) ? "active" : "") + " client-inventory-link"}
        >
          {renter1.name} Inventory
        </a>
      )
    }
    if(isJaguar(user) || isSuperadmin(user)) {
      return (
        <>
          <a 
            className={this.isSubheaderActive("inventory", null) ? "active" : ""}
            href="/"
          >
            Inventory
          </a>
        </>
      )
    } else {
      return (
        <a 
          className="active"
          href="/"
        >
          Inventory
        </a>
      )
    }
  }

  getBackgroundWaveColor(){
    const { subHeader } = this.props;
    if(subHeader && subHeader.type && subHeader.type.getBackgroundColor){
      return subHeader.type.getBackgroundColor()
    }
    return "transparent"
  }

  //TODO Better Solution
  getSortOrder(group){
    switch(group){
      case "Seating":
        return 0;
      case "Tables":
        return 1;
      case "Decor":
        return 2;
      case "Signage":
        return 3;
      case "Electrical":
        return 4 ;
      default:
        1000;
    }
  }
  
  updateSearchInput(e){
    this.setState({
      searchInput: e.target.value
    })
  }

  searchSubmit(e){
    e.preventDefault()
    e.stopPropagation()
    const {searchInput } = this.state;
    const params = [`query=${searchInput}`].join('&');
    const url =  `/items/search?${params}`
    window.location.href = url
  }

  renderSearch() {
    return (
      <div className="navbar-search">
        <form id="searchbar" onSubmit={this.searchSubmit}>
          <TextField
            variant="outlined"
            size="small"
            onChange={this.updateSearchInput}
            placeholder={isJaguar(this.props.user) ? "Search All Inventories" : "Search Inventory"}
            sx={{
              //background: "white",
              base: {
                background: "white",
              },
              root: {
                backgroundColor: "white",
              }
            }}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <SearchIcon />
                </InputAdornment>
              ),
            }}
          />
        </form>
      </div>
    )
  }

  renderProfile() {
    const { userMenuOpen } = this.state;
    const { user } = this.props;
    if (user.id !== null) {
      return (
        <div className="navbar-profile" onClick={
          (e) => {
            this.setState({userMenuOpen: !userMenuOpen})
            e.stopPropagation()
            e.preventDefault()
          }
        }>
           
          <div role="button" className="navbar-profile-button">
            <img src="/images/user-person.svg"/>
            Hi {user.first_name}!
            {userMenuOpen ? (
              <UserMenu user={user}/>
            ):""}
            
          </div>
        </div>
      );
    }else {
      return (
        <a className="navbar-profile" href="/users/sign_in">
          <div role="button" className="navbar-profile-button">
            Sign In
          </div>
        </a>
      );
    }
  }

  renderBreadcrumbs() {
    const { breadcrumbs } = this.props;
    if(!breadcrumbs) {
      return null
    }
    return (
      <BreadcrumbsSubheader links={breadcrumbs} />
    )
  }
  
  renderGroups() {
    const { disableGroups } = this.props
    const activeSubheader = this.getCurrentActiveSubheader()
    if ( activeSubheader.name == "inventory" && !disableGroups) { 
      return (
        <div className="sub-sub-navbar">
          <div className="container">
            <div className="sub-sub-navbar-categories">
              {this.renderGroupLinks()}
            </div>
          </div>
        </div>
      )
    }else {
      return (
        <div className="sub-sub-navbar">
        </div>
      )
    }
  }

  renderClientsInventory() {
    const { user, renter } = this.props;
    if(isJaguar(user) || isSuperadmin(user)){
      return (
        renter && !renter.jaguar ? (
          <a 
            className={(this.isSubheaderActive("inventory", renter.id) ? "active" : "") + " client-inventory-link"}
            href={`/inventory/${renter.id}`}
          >
            {renter.name} Inventory
          </a>
        ): ""
      )
    }
  }



  render() {
    const { currentPage, user } = this.props;
    return (
      <div className="catalog-navbar">
        <div className="catalog-navbar-header">
          <div className="container" style={{maxWidth: "1000px",margin: "0", padding: "0"}}>
            <a href="/">
              <img className="catalog-navbar-header-image" src="/images/header-background.png"/>
            </a>
          </div>
          <div className="catalog-navbar-header-interactables">
            {this.renderSearch()}
            {this.renderProfile()}
          </div>
        </div>

        <div className="sub-navbar">
          <div className="container">
            <ul className="sub-navbar-categories">
              {this.renderInventory()}
              {this.renderEventsLink()}
              {this.renderOrdersLink()}
              {this.renderRecievingList()}
              {this.renderReportsLink()}
              {this.renderClientsLink()}
              {this.renderClientsInventory()}
            </ul>
          </div>
        </div>
        {this.renderBreadcrumbs()}
        {this.renderGroups()}
      </div>
    );
  }
}

PublicCatalogNavbar.propTypes = {

};

export default PublicCatalogNavbar;
